module.exports = __webpack_public_path__ + "static/media/WordPress logo.28fa4551.svg";